<template>
  <div>Import Users</div>
</template>

<script>
export default {
  name: "ImportUsers"
}
</script>